<template>
  <b-container fluid class="bg-dark">
    <b-navbar class="container" toggleable="lg" type="dark">
      <b-navbar-brand
        v-if="isLoggedIn()"
        @click.prevent="
          $router.push(
            `/stock/${$store.getters.outputOfStockSymbol}/report-year`
          )
        "
        >goldway</b-navbar-brand
      >
      <b-navbar-brand v-else @click.prevent="$router.push({ name: 'login' })"
        >goldway</b-navbar-brand
      >
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="w-100">
          <b-nav-item
            to="/stock/2330/report-year"
            :class="{ active: currentNav === 'stock' }"
            v-if="$store.getters.isLogin"
            >個股</b-nav-item
          >
          <b-nav-item
            to="/screener"
            :class="{ active: currentNav === 'screener' }"
            v-if="$store.getters.isLogin"
            >選股</b-nav-item
          >
          <b-nav-item
            to="/statistics/price-to-earning-ratio"
            :class="{ active: currentNav === 'statistics' }"
            v-if="$store.getters.isLogin"
            >統計</b-nav-item
          >
          <b-nav-item
            to="/newlyAdded/news-all"
            :class="{ active: currentNav === 'newlyAdded' }"
            v-if="
              $store.getters.isLogin && $store.getters.loggedInInfo.is_admin
            "
            >近期新增</b-nav-item
          >
          <b-nav-item
            to="/website-descriptions?page=1"
            :class="{ active: currentNav === 'website-description' }"
            v-if="
              $store.getters.isLogin
            "
            >網站說明</b-nav-item
          >
          <b-nav-item
            class="ml-auto"
            to="/accountCenter/applying"
            :class="{ active: currentNav === 'accountCenter' }"
            v-if="
              $store.getters.isLogin && $store.getters.loggedInInfo.is_admin
            "
            >帳號管理</b-nav-item
          >
          <b-nav-item
            to="/userCenter/userInfo"
            :class="{
              active: currentNav === 'userCenter',
              'ml-auto': !$store.getters.loggedInInfo.is_admin
            }"
            v-if="$store.getters.isLogin"
            >會員中心</b-nav-item
          >
          <b-nav-item v-if="$store.getters.isLogin" @click="logout"
            >登出 ( Hi，{{
              $store.getters.loggedInInfo.is_admin
                ? "Admin"
                : $store.getters.loggedInInfo.account
            }}
            )</b-nav-item
          >
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </b-container>
</template>

<script>
const NAV_LIST = [
  "stock",
  "screener",
  "statistics",
  "accountCenter",
  "userCenter",
  "newlyAdded",
  "website-description"
];
import Cookies from "js-cookie";
export default {
  name: "NavBar",
  computed: {
    currentNav() {
      return NAV_LIST.filter(nav => {
        return this.$route.path.includes(nav);
      })[0];
    },
    isLoggedIn() {
      return () => Cookies.get("chuenStock");
    }
  },
  methods: {
    logout() {
      this.$store.commit("logout");
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar-dark .navbar-brand {
  color: gray;
  cursor: pointer;
}
.navbar-dark .navbar-brand:hover {
  color: gray;
}
.navbar-dark .navbar-nav .active .nav-link {
  color: white;
}
.navbar-dark .navbar-nav .nav-link:hover {
  color: white;
}
</style>
